<div style="margin-bottom: 20px">
  <div style="visibility: hidden">
    <app-configure-filters uniqueKey="audit_log"></app-configure-filters>
  </div>
  <app-generic-list [onLazyLoad]="load" [api]="api" [forceFilters]="forceFilters" [styleHeight]="''"
                    [updateUrlOnLoad]="false" uniqueKey="audit_log">

    <app-generic-column key="timestamp" [filterType]="FilterType.DATE" i18n-title="@@audit-log-date-changed" title="Date changed">
      <ng-template let-item>
        {{ identity(item).timestamp | date:'yyyy-MM-dd HH:mm' }}
      </ng-template>
    </app-generic-column>

    <app-generic-column key="actor__email" i18n-title="@@audit-log-email" title="Email"></app-generic-column>

    <app-generic-column key="action" i18n-title="@@audit-log-action" title="Action">
      <ng-template let-item>
        {{ utilitiesService.getLocalisedLookup(identity(item).action, actions) }}
      </ng-template>
    </app-generic-column>

    <app-generic-column key="changes" i18n-title="@@audit-log-changes" title="Changes" [enableSort]="false" minWidth="400px">
      <ng-template let-item>
        <span [innerHTML]="formatChanges(identity(item).changes_dict)"></span>
      </ng-template>
    </app-generic-column>

  </app-generic-list>

</div>

<div style="margin: 30px 0 10px 0; text-align: right">
  <div class="field-label">
    <p-button icon="fa fa-solid fa-xmark" i18n-label="@@common-close" label="Close" (onClick)="onClose()" severity="secondary"></p-button>
  </div>
</div>
